<template>
  <a :href="cardInfo.link" target="_blank" class="card-box">
    <div class="category">{{cardInfo.category}}</div>
    <h1 class="title">{{cardInfo.title}}</h1>
    <p class="text">{{cardInfo.text}}</p>
  </a>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
  @import '@/style/app.sass';

  .card-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: calc(33.333% - 20px);
    height: 170px;
    padding: 43px 21px 23px 21px;
    background: #fff;
    border-radius:5px;
    box-sizing: border-box;
    margin-bottom: 20px;
    margin-right: 30px;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
    &:nth-last-of-type(2) {
      margin-bottom: 0;
    }
    &:nth-last-of-type(3) {
      margin-bottom: 0;
    }
    @include mobile {
      width: 90vw;
      height: 145px;
      padding: 36px 18px 18px 18px;
      margin-bottom: 13px;
      margin-right: 0;
      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
      &:nth-last-of-type(2) {
        margin-bottom: 13px;
      }
      &:nth-last-of-type(3) {
        margin-bottom: 13px;
      }
    }

    .category {
      position: absolute;
      top: 0;
      left: 21px;
      width: 79px;
      height: 22px;
      font-size: 12px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 22px;
      background: rgba(52, 168, 83, 1);
      box-shadow: 0px 2px 5px 0px rgba(52, 168, 83, 0.2);
      border-radius: 0px 0px 4px 4px;
      @include mobile {
        width: 76px;
        height: 21px;
        font-size: 12px;
        left: 20px;
      }
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(32,33,36,1);
      line-height: 1.2;
      // margin-bottom: 18px;
      @include mobile {
        font-size: 17px;
        line-height: 1.3;
      }
    }

    .text {
      font-size: 16px;
      font-weight: 400;
      color: rgba(95,99,104,1);
      line-height: 1.4;
      // margin-bottom: 18px;
      @include limit-line-numbers(2);
      @include mobile {
        font-size: 13px;
      }
    }

  }
</style>
